import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('recalculate-commission-dialog',{attrs:{"items":[_vm.value]},on:{"onSuccess":function($event){return _vm.$emit('onSuccess')}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var dialogOn = ref.on;
var dialogAttrs = ref.attrs;
return [_c(VTooltip,{attrs:{"bottom":"","outlined":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn,_vm._g(_vm._b({attrs:{"depressed":"","fab":"","small":""}},'v-btn',Object.assign({}, _vm.$attrs, dialogAttrs, attrs),false),Object.assign({}, dialogOn, on)),[_c(VIcon,{attrs:{"small":""}},[_vm._v("mdi-calculator")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('Recalculate')))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }